import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'

// Components
import BaseButton from './components/ui/BaseButton.vue'
import BaseCard from './components/ui/BaseCard.vue'
import BaseSection from './components/ui/BaseSection.vue'
import BaseLoading from './components/ui/BaseLoading.vue'

// Styles
import '@/styles/main.scss';

// Font Awesome
import FontAwesomeIcon from '@/fontAwesome';

const app = createApp( App )
app.component( 'fa-icon', FontAwesomeIcon )
app.component( 'BaseButton', BaseButton )
app.component( 'BaseCard', BaseCard )
app.component( 'BaseSection', BaseSection )
app.component( 'BaseLoading', BaseLoading )
app.use( store )
app.use( router )
app.use( i18n )
app.mount( '#simply-flights-frontend' )